angular.module('util.trsScrollFixForModalModule', []).
directive("trsScrollFixForModal", ["$timeout", function($timeout) {

    return {
        restrict: 'EA',
        link: function($scope, $element, $attrs) {

            //if (!$attrs['enableFix']) return;

            var fixTop = parseInt($attrs['fixTop'] || 0, 10);

            var fixIncWidth = parseInt($attrs['fixIncWidth'] || 0, 10);

            $(".modal").bind('scroll', scrollHandler);

            $scope.$on('$destroy', function() {
                $(".modal").unbind('scroll', scrollHandler);
            });


            /**
             * 滚动过程中，将absolute和fixed进行转换
             */
            function scrollHandler() {
                initPosition();

                initFixRelativeElement();

                //获取相对元素的坐标，与相对元素进行位置比较
                if (fixRelativeElement && fixRelativeElement.size() > 0) {
                    var fixBounding = fixRelativeElement[0].getBoundingClientRect();
                    if (fixBounding.top < 0) {

                        var visibleHeight = fixRelativeElement.height() + fixBounding.top;

                        initFixBoxElement();
                        var elementHeight = fixBoxElement.height();

                        //相对元素可见区域搞定即将与当前元素高度相等
                        if (visibleHeight <= elementHeight) {
                            $element.css({
                                position: 'fixed',
                                left: initialBounds.left,
                                top: -(elementHeight - visibleHeight) + 'px',
                                margin: 'auto',
                                width: Math.floor(initialBounds.right - initialBounds.left + fixIncWidth) + 'px',
                                height: (initialBounds.bottom - initialBounds.top) + 'px'
                            });
                            $element.addClass('scroll-fix-active');
                            return;
                        }
                    }
                }

                var scrollTop = $(".modal")[0].scrollTop - fixTop;

                if (scrollTop >= initialBounds.top) {
                    $element.css({
                        position: 'fixed',
                        left: initialBounds.left,
                        top: scrollTop - 30 + 'px',
                        margin: 'auto',
                        height: (initialBounds.bottom - initialBounds.top) + 'px'
                    });
                    $element.addClass('scroll-fix-active');
                } else {
                    $element.removeAttr("style");
                    $element.removeClass('scroll-fix-active');
                }
            }

            //滚动前距离窗口顶部的位置
            var initialBounds = null;

            //滚动前当前元素的定位
            var initialPositionStyle = null;

            function initPosition() {
                if (!initialPositionStyle) {
                    initialPositionStyle = {
                        position: $element.css('position'),
                        left: $element.css('left'),
                        top: $element.css('top'),
                        width: $element.css('width'),
                        height: $element.css('height'),
                        marginLeft: $element.css('marginLeft'),
                        marginRight: $element.css('marginRight'),
                        marginTop: $element.css('marginTop'),
                        marginBottom: $element.css('marginBottom')
                    };
                }

                if (!initialBounds || (initialBounds.top == initialBounds.bottom)) {
                    var scrollTop = $(".modal")[0].scrollTop;
                    var scrollLeft = $(".modal")[0].scrollLeft;

                    initialBounds = $element[0].getBoundingClientRect();
                    initialBounds = {
                        top: initialBounds.top + scrollTop,
                        right: initialBounds.right + scrollLeft,
                        bottom: initialBounds.bottom + scrollTop,
                        left: 0
                    };
                }
            }

            //初始化固定过程中，需要顶部切片的参考元素
            var fixRelativeElement;

            function initFixRelativeElement() {
                if (fixRelativeElement && fixRelativeElement.length !== 0) {
                    return;
                }

                if (!$attrs['fixRelativeElement']) {
                    return;
                }

                fixRelativeElement = $attrs['fixRelativeElement'];
                fixRelativeElement = $(fixRelativeElement);
            }

            //初始化移动过程中，当前浮动元素的高度计算标准
            var fixBoxElement;

            function initFixBoxElement() {
                if (fixBoxElement) {
                    return;
                }

                if ($attrs['fixBoxElement']) {
                    fixBoxElement = $($attrs['fixBoxElement']);
                }

                fixBoxElement = fixBoxElement || $element;
            }

        }
    };
}]);